import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {ConfigKey, GET_CONFIGURATION_PATH} from './configuration.model';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class ConfigurationService {
  constructor(
    private http: HttpClient) {
  }

  getConfiguration(configKey: ConfigKey): Observable<String> {
    const options = {params: new HttpParams({fromObject: {configKey}})};
    return this.http.get<String>(GET_CONFIGURATION_PATH, options);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/configuration.service.ts